/* global site */
var ctrlopt = ctrlopt;

(function ($) {
  var pCounterId, pServicdesId, pAppointmentId, pToken, pStoreNumber,
    loc = window.location,
    nextSection = 'counters',
    apptBook = Drupal.appointmentBooking,
    modelSectionData = [
      {
        id: 'counters',
        jqElem: $('#counters')
      },
      {
        id: 'services',
        jqElem: $('#services')
      },
      {
        id: 'appointments',
        jqElem: $('#appointments')
      },
      {
        id: 'review',
        jqElem: $('#review')
      },
      {
        id: 'confirmation',
        jqElem: $('#confirmation')
      }

    ];

  function getURLParam(oTarget, sVar) {
    return decodeURI(oTarget.search.replace(new RegExp('^(?:.*[&\\?]' + encodeURI(sVar).replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1'));
  }

  pCounterId = getURLParam(loc, 'counter_id');
  pStoreNumber = getURLParam(loc, 'store_number');
  pServicdesId = getURLParam(loc, 'services_id');
  pAppointmentId = getURLParam(loc, 'appointment_id');
  pToken = getURLParam(loc, 'token');

  Drupal.behaviors.apptBook = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      var updateObj,
        updateParams = null,
        hasCounters = false,
        hasServices = false,
        $sectionsContainer = $('.js-appointment-book-sections', context),
        $sections = $sectionsContainer.find('.js-appt-book-section', context),
        sectionManager = apptBook.sectionManager.init($sectionsContainer, $sections),
        mData = { data: modelSectionData },
        self = this;

      self.setVirtual('virtual_oab', 0);
      if (pToken) {
        mData.token = pToken;
      }

      function setCounters(data) {
        if (!data || !data.length) {
          window.location = '/';

          return;
        }
        hasCounters = true;
        if (hasServices) {
          run();
        }
      }

      function setServices() {
        hasServices = true;
        if (hasCounters) {
          run();
        }
      }

      function run() {
        var currentSection, $header, $tabs, $title, $subhead, $content, $image;

        sectionManager.setModel(apptBook.sectionModel).startObserving();
        apptBook.historyHandler.setModel(apptBook.sectionModel).startObserving();

        if (pStoreNumber) {
          var foundCounterByNumber = apptBook.sectionModel.countersData.find(function (element) {
            return element.store_no === pStoreNumber;
          });

          if (foundCounterByNumber) {
            var counterService = apptBook.sectionModel.servicesData.filter(function (element) {
              return element.id === foundCounterByNumber.service_ids[0];
            })[0];

            // For the time being the underlying assumption here is that a counter either supports virtual services OR
            // non-virtual services, but never both -- CDIAL
            if (counterService && counterService.virtual === '1') {
              self.setVirtual('virtual_oab', 1);
            }
            pCounterId = foundCounterByNumber.id;
          }
        }

        if (pCounterId && pServicdesId) {
          nextSection = 'appointments';
          updateParams = {
            sectionId: nextSection,
            counterId: pCounterId,
            servicesId: pServicdesId.split(',')
          };
        } else if (pCounterId) {
          nextSection = 'services';
          updateParams = {
            sectionId: nextSection,
            counterId: pCounterId
          };
        }

        if (pAppointmentId) {
          nextSection = 'appointments';
          updateParams = {
            appointmentId: pAppointmentId
          };
        }

        updateObj = {
          sectionId: nextSection,
          params: updateParams
        };

        // Subscribe to sectionModel update events and update the page header and the page indication tabs
        apptBook.sectionModel.on('update', function (data) {
          var config = Drupal.settings.appointment_booking_main_collection,
            section = data.sectionId,
            virtual_oab = Drupal.settings.virtual_oab || 0,
            physical_oab = Drupal.settings.physical_oab_disabled ? 0 : 1;

          if (section === currentSection) {
            return;
          }

          $header = $('.js-appt-book-header');
          $tabs = $('.js-appt-book-header-tabs', $header);
          $title = $('.js-appt-book-header-title', $header);
          $subhead = $('.js-appt-book-header-subhead', $header);
          $content = $('.js-appt-book-header-content', $header);
          $image = $('.js-appt-book-header-picture', $header);

          var s = {};

          for (var key in config) {
            if (!config.hasOwnProperty(key)) {
              continue;
            }

            s = config[key];
            if (s['section_key'] === section) {
              break;
            }
          }

          if (!$.isEmptyObject(s)) {
            if (s['section_key'] === 'confirmation' || (s['section_number'] === '1' && virtual_oab && !physical_oab)) {
              $tabs.hide();
            } else {
              $tabs.show();
            }

            var i = s['section_number'];

            if (i.length > 0) {
              $('li', $tabs)
                .removeClass('active')
                .filter('.js-tab-' + i)
                .addClass('active');
            } else {
              $('li', $tabs).removeClass('active');
            }

            $title.html(s['section_title']);
            $subhead.html(s['section_subhead']);
            $content.css('height', $image.css('height'));
          }

          currentSection = section;
        });

        apptBook.sectionModel.update(updateObj);
      }

      apptBook.sectionModel.on('data_set', function () {
        apptBook.sectionModel.off('data_set');
        apptBook.sectionModel.getCounters(setCounters);
        apptBook.sectionModel.getServices(setServices);
      });

      apptBook.sectionModel.setData(mData);
    },
    setVirtual: function (key, value) {
      localStorage.setItem(key, value);
    },
    attached: false
  };
})(jQuery);
